// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jg_a bhr_a bhr_j bhr_q bhr_sv bhr_sw bhr_w"};